export const callTypeHeaders = [
  {
    text: "Call Type Id",
    value: "id"
  },
  {
    text: "Call Type",
    value: "name"
  },
  {
    text: "Created On",
    value: "created_at"
  },
  {
    text: "Last Updated At",
    value: "updated_at"
  },
  {
    text: "Actions...",
    sortable: false,
    value: "actions"
  }
];

export const dispositionHeaders = [
  {
    text: "Disposition Id",
    value: "id"
  },
  {
    text: "Disposition Type",
    value: "name"
  },
  {
    text: "Call Type",
    value: "call_type"
  },
  {
    text: "Created On",
    value: "created_at"
  },
  {
    text: "Last Updated At",
    value: "updated_at"
  },
  {
    text: "Actions...",
    sortable: false,
    value: "actions"
  }
];
